import { render, staticRenderFns } from "./Box_Art.vue?vue&type=template&id=591ffeea&scoped=true"
import script from "./Box_Art.vue?vue&type=script&lang=js"
export * from "./Box_Art.vue?vue&type=script&lang=js"
import style0 from "./Box_Art.vue?vue&type=style&index=0&id=591ffeea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ffeea",
  null
  
)

export default component.exports